// extracted by mini-css-extract-plugin
export default {"list":"styles__list___CisOC","item":"styles__item___E0tQv","link":"styles__link___pMi3P link__button___3l2Cw base__button___zT0JW"};